define(["require", "exports", "../services/toastNotification"], function (require, exports, toastNotification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CopyButton = (function () {
        function CopyButton(value, iconPath, buttonSelector) {
            if (iconPath === void 0) { iconPath = '/static/icons/copy.svg'; }
            if (buttonSelector === void 0) { buttonSelector = 'copy-button'; }
            this._value = value;
            this._iconPath = iconPath;
            this._buttonSelector = buttonSelector;
        }
        CopyButton.AddEventHandler = function (sourceElement, maleText) {
            var _this = this;
            if (maleText === void 0) { maleText = true; }
            sourceElement.addEventListener('click', function () { return _this.CopyValue(sourceElement, maleText); });
        };
        CopyButton.CopyValue = function (sourceElement, maleText) {
            var input = sourceElement.querySelector('input[type="hidden"]');
            input.type = 'text';
            input.select();
            input.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(input.value);
            input.type = 'hidden';
            var copied = maleText ? 'copiado' : 'copiada';
            toastNotification_1.ToastNotification.Success(sourceElement.dataset.name + " '" + input.value + "' " + copied + " com sucesso.", 2000);
        };
        CopyButton.prototype.Create = function (nameForMessage) {
            var button = document.createElement("button");
            button.type = 'button';
            button.className = this._buttonSelector + " w-full";
            button.dataset.name = nameForMessage;
            var span = document.createElement("span");
            span.className = 'flex flex-col w-full items-center';
            var img = document.createElement("img");
            img.className = "flex-shrink flex-auto w-16 h-4";
            img.src = this._iconPath;
            span.appendChild(img);
            var hiddenInput = document.createElement("input");
            hiddenInput.type = 'hidden';
            hiddenInput.value = this._value;
            button.appendChild(span);
            button.appendChild(hiddenInput);
            return button.outerHTML;
        };
        return CopyButton;
    }());
    exports.default = CopyButton;
});
